import { useRoutes } from "react-router-dom";
import CreateCard from "../../../Component/CreateCard.js"
import ProtectedRoute from "../../RouteProtect.js"

import RoleList from './Role/View.js'
import RoleCreate from './Role/Create.js'

import RoleMappingList from './RoleMapping/View.js'
import RoleMapping from './RoleMapping/Create.js'

const MarketingManagementCardArray = [
    {
        title: "Role",
        path: "roleList",
        auth: "carrier",
    },
    {
        title: "Role Mapping",
        path: "roleMappingList",
        auth: "carrier",
    }
]
const MarketingManagementRoutesArray = [
    {
        path: "/",
        element: <CreateCard cardJson={[...MarketingManagementCardArray]} />
    },
    {
        path: "*",
        element: <>This is 404</>
    },
    {
        path: "roleList/*",
        element: <RoleList />
    },
    {
        path: "roleList/createRole*",
        element: <RoleCreate />
    },
    {
        path: "roleMappingList/*",
        element: <RoleMappingList />
    },
    {
        path: "roleMappingList/roleMapping*",
        element: <RoleMapping />
    }

]

export default function MarketingManagementRoutes() {
    return useRoutes(MarketingManagementRoutesArray)
}